var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('timeline-item',{attrs:{"type":"SMS","date":_vm.message.date_sent},scopedSlots:_vm._u([{key:"body",fn:function(){return [_vm._v(_vm._s(_vm.message.content))]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }